import { QuestionMessageType } from '@data/types';
import classNames from 'classnames';
import React from 'react';

interface Props extends QuestionMessageType {}

const QuestionMessage: React.FC<Props> = ({ answers }) => {
  const classes = 'text-xs md:text-sm mb-6 font-lighterNormal';

  // If there are more than 2 answers, return "Choose one"
  if (answers.length > 2 && answers[0]?.type === 'button') {
    return <div className={classNames('', classes)}>(Choose one)</div>;
  }

  // Check if the first answer has options
  if (answers[0]?.options) {
    const typeMessages: { [key: string]: string } = {
      drag: '5 = excellent and 1 = poor',
      multiSelect: 'Select one from each option',
      radial: 'Select one from each option',
    };

    // Return the message based on the type, or an empty string if type not found
    return (
      <div className={classNames('', classes)}>
        {typeMessages[answers[0]?.type as 'drag' | 'multiSelect' | 'radial'] ||
          ''}
      </div>
    );
  }

  return <></>;
};

export default QuestionMessage;
